/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobBatchRequest extends models.RecordIdentityBatchRequest {
    getFixupPrototypeFunction() { return BackgroundJobBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobBatchRequest>): BackgroundJobBatchRequest {
        let obj = Object.assign(new BackgroundJobBatchRequest(), model);
        BackgroundJobBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobBatchRequest>): BackgroundJobBatchRequest {
        if (!model) return null;
        return BackgroundJobBatchRequest.newInstance(<BackgroundJobBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobBatchRequest) {
        if (!obj) return;

        models.BackgroundJobBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobBatchRequest): boolean {
        if (models.RecordIdentityBatchRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Include payload details if true
     */
    include_details: boolean;

    /**
     * Include just the status field if true
     */
    include_only_status: boolean;

}
